import React, { ReactNode } from 'react';
import { EventsProvider } from '@jbhi-fi/components/src/context/Events/EventsProvider';
import { algoliaEventHandlers } from './algoliaEventHandlers';
import { jbEventHandlers } from './jbEventHandlers';

export const ShopifyEventsProvider = ({ children }: { children: ReactNode }) => {
  return <EventsProvider eventHandlers={[algoliaEventHandlers, jbEventHandlers]}>{children}</EventsProvider>;
};
